import type { DemoScript } from "../types";
import { CAMPANHAS_SCRIPT_COPY } from "./campanhas-script.copy";

export const buildCampanhasScript = (): DemoScript => [
  {
    id: "camp-intro",
    narrative: CAMPANHAS_SCRIPT_COPY.campIntro.narrative,
    durationMs: 3000,
  },
  {
    id: "camp-grid",
    narrative: CAMPANHAS_SCRIPT_COPY.campGrid.narrative,
    zoomTargetId: "campanhas-grid",
    callout: {
      targetId: "campanhas-grid",
      text: CAMPANHAS_SCRIPT_COPY.campGrid.callout,
    },
    durationMs: 5400,
  },
  {
    id: "camp-modal-open",
    narrative: CAMPANHAS_SCRIPT_COPY.campModalOpen.narrative,
    zoomTargetId: "campanhas-modal",
    callout: {
      targetId: "campanhas-modal",
      text: CAMPANHAS_SCRIPT_COPY.campModalOpen.callout,
    },
    durationMs: 5200,
  },
  {
    id: "camp-modal-title",
    narrative: CAMPANHAS_SCRIPT_COPY.campModalTitle.narrative,
    zoomTargetId: "camp-modal-title",
    callout: {
      targetId: "camp-modal-title",
      text: CAMPANHAS_SCRIPT_COPY.campModalTitle.callout,
    },
    durationMs: 5200,
  },
  {
    id: "camp-modal-brand",
    narrative: CAMPANHAS_SCRIPT_COPY.campModalBrand.narrative,
    zoomTargetId: "camp-modal-brand",
    callout: {
      targetId: "camp-modal-brand",
      text: CAMPANHAS_SCRIPT_COPY.campModalBrand.callout,
    },
    durationMs: 5200,
  },
  {
    id: "camp-modal-deadline",
    narrative: CAMPANHAS_SCRIPT_COPY.campModalDeadline.narrative,
    zoomTargetId: "camp-modal-deadline",
    callout: {
      targetId: "camp-modal-deadline",
      text: CAMPANHAS_SCRIPT_COPY.campModalDeadline.callout,
    },
    durationMs: 5400,
  },
  {
    id: "camp-modal-deliverables",
    narrative: CAMPANHAS_SCRIPT_COPY.campModalDeliverables.narrative,
    zoomTargetId: "camp-modal-deliverables",
    callout: {
      targetId: "camp-modal-deliverables",
      text: CAMPANHAS_SCRIPT_COPY.campModalDeliverables.callout,
    },
    durationMs: 5400,
  },
  {
    id: "camp-modal-deliverables-list",
    narrative: CAMPANHAS_SCRIPT_COPY.campModalDeliverablesList.narrative,
    zoomTargetId: "camp-modal-deliverables-table",
    callout: {
      targetId: "camp-modal-deliverables-table",
      text: CAMPANHAS_SCRIPT_COPY.campModalDeliverablesList.callout,
    },
    durationMs: 5200,
  },
  {
    id: "camp-modal-payment",
    narrative: CAMPANHAS_SCRIPT_COPY.campModalPayment.narrative,
    zoomTargetId: "camp-modal-payment",
    callout: {
      targetId: "camp-modal-payment",
      text: CAMPANHAS_SCRIPT_COPY.campModalPayment.callout,
    },
    durationMs: 5400,
  },
  {
    id: "camp-modal-payment-total",
    narrative: CAMPANHAS_SCRIPT_COPY.campModalPaymentTotal.narrative,
    zoomTargetId: "camp-modal-payment-total",
    callout: {
      targetId: "camp-modal-payment-total",
      text: CAMPANHAS_SCRIPT_COPY.campModalPaymentTotal.callout,
    },
    durationMs: 5200,
  },
  {
    id: "camp-outro",
    narrative: CAMPANHAS_SCRIPT_COPY.campOutro.narrative,
    durationMs: 2800,
  },
];
